import { getEmployeeParams } from '../../utils/reducers/getters'

interface AppStyleDeciderProps {
    NewComponent: React.FC<any>
    DefaultComponent: React.FC<any>
    [key: string]: any
}

const AppStyleDecider: React.FC<AppStyleDeciderProps> = ({ NewComponent, DefaultComponent, ...rest }) => {
    const defaultStyle = getEmployeeParams()?.['appStyle'] || 'new1'
    if (defaultStyle === 'new1') {
        return <NewComponent {...rest} />
    }
    return <DefaultComponent {...rest} />
}

export default AppStyleDecider